import * as React from 'react';
import {
  classNames,
  FontFamily,
  FontSize,
  FontWeight,
  HeadingProps,
  TextAlign
} from '@snoam/pinata';
import { Heading } from '@snoam/pinata';

const styleClass = {
  heading: classNames(
    FontFamily.FONT_TITLE_1,
    FontSize.TEXT_2XL,
    FontWeight.FONT_MEDIUM,
    TextAlign.TEXT_CENTER
  )
};

export const PageHeading: React.FunctionComponent<HeadingProps> = props => {
  const { level, children } = props;
  return (
    <Heading level={level} className={styleClass.heading}>
      {children}
    </Heading>
  );
};

PageHeading.displayName = "PageHeading";
